import { useId } from 'react';

// Label + control + hint/error wrapper used by Input, Textarea, Select, Combobox and DatePicker.
export default function Field({ label, hint, error, children, className }) {
  const id = useId();
  const describedBy = error ? `${id}-err` : hint ? `${id}-hint` : undefined;
  return (
    <div className={['ui ui-field', className].filter(Boolean).join(' ')}>
      {label && <label className="ui-field__label" htmlFor={id}>{label}</label>}
      {children({ id, describedBy, invalid: !!error })}
      {error ? <span className="ui-field__error" id={`${id}-err`}>{error}</span> : hint ? <span className="ui-field__hint" id={`${id}-hint`}>{hint}</span> : null}
    </div>
  );
}
